import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

const BillingInformationView = (props: any) => {
    const history: any = useHistory();
    const [isETF, setIsETF] = useState(false);
    const { t: tLang } = useTranslation();

    useEffect(() => {
        if (
            props.billingInfo &&
            props.billingInfo.paymentMethod &&
            props.billingInfo.paymentMethod.selection &&
            props.billingInfo.paymentMethod.selection === "EFT"
        ) {
            setIsETF(true);
        } else {
            setIsETF(false);
        }
    }, [props.billingInfo]);

    useEffect(() => {
        if (history.location && history.location.state && history.location.state.fromBillingPage) {
            const element = document.getElementById("label-billing-payment-history");
            if (element) {
                element.scrollIntoView({ behavior: "smooth", block: "end" });
            }
        }
    }, []);

    const getAccountOrCardType = () => {
        let accountOrCardType = "";
        if (isETF) {
            accountOrCardType =
                props.billingInfo && props.billingInfo.eft && props.billingInfo.eft.accountType && props.billingInfo.eft.accountType.selection
                    ? props.billingInfo.eft.accountType.selection
                    : "";
        } else {
            accountOrCardType =
                props.billingInfo && props.billingInfo.creditCard && props.billingInfo.creditCard.cardType && props.billingInfo.creditCard.cardType.selection
                    ? props.billingInfo.creditCard.cardType.selection
                    : "";
            const cardTypeKeyValue = [
                { key: "VISA", value: "Visa" },
                { key: "MASTERCARD", value: "Mastercard" },
                { key: "DISCOVER", value: "Discover" },
                { key: "AMEX", value: "American Express" },
            ];

            const cardObjectWithKeyValue = cardTypeKeyValue.find((card) => card.key === accountOrCardType || card.value === accountOrCardType);
            if (cardObjectWithKeyValue) {
                accountOrCardType = cardObjectWithKeyValue.value;
            }
        }
        return accountOrCardType;
    };

    const getAccountOrCardNumber = () => {
        let accountOrCardType = "";
        if (isETF) {
            accountOrCardType = props.billingInfo && props.billingInfo.eft && props.billingInfo.eft.accountNumber ? props.billingInfo.eft.accountNumber : "";
        } else {
            accountOrCardType =
                props.billingInfo && props.billingInfo.creditCard && props.billingInfo.creditCard.cardNumber ? props.billingInfo.creditCard.cardNumber : "";
        }
        return accountOrCardType;
    };

    return (
        <React.Fragment>
            <div role="grid" className="data-grid " id="billing-grid" aria-hidden="false">
                <div role="row" className="data-row row">
                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                        <div className="data-label" id="label-billing-payment-method">
                            {tLang("manageAccount.myAccount.billing.label.paymentMethod")}
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                        <div role="gridcell" className="data-value" aria-labelledby="label-billing-payment-method">
                            {props.billingInfo && props.billingInfo.paymentMethod && props.billingInfo.paymentMethod.name
                                ? props.billingInfo.paymentMethod.name
                                : ""}
                        </div>
                    </div>
                </div>

                {getAccountOrCardType() && (
                    <div role="row" className="data-row row">
                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                            <div className="data-label" id="label-billing-card-type">
                                {isETF ? tLang("manageAccount.myAccount.billing.info.account-type") : tLang("manageAccount.myAccount.billing.info.card-type")}
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                            <div role="gridcell" className="data-value" aria-labelledby="label-billing-card-type">
                                {getAccountOrCardType()}
                            </div>
                        </div>
                    </div>
                )}

                <div role="row" className="data-row row">
                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                        <div className="data-label" id="label-billing-card-number">
                            {isETF ? tLang("manageAccount.myAccount.billing.info.account-number") : tLang("manageAccount.myAccount.billing.info.card-number")}
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                        <div role="gridcell" className="data-value" aria-labelledby="label-billing-card-number">
                            {getAccountOrCardNumber()}
                        </div>
                    </div>
                </div>

                <div role="row" className="data-row row">
                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                        <div className="data-label" id="label-billing-payment-history">
                            {tLang("manageAccount.myAccount.billing.label.paymentHistory")}
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                        <div role="gridcell" className="data-value" aria-labelledby="label-billing-payment-history">
                            <Link to="/payment-history" className="default_link">
                                {tLang("manageAccount.myAccount.billing.label.viewPaymentHistory")}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default BillingInformationView;
